/**
 * Quick test to see if kustomer chat is an option.  Just playing around in staging.
 */
export default defineNuxtPlugin(() => {
  const { $sitewideConfig } = useNuxtApp()
  if ($sitewideConfig.domain !== 'staging.realtruck.com') return
  //const { isIntegrationEnabled } = useUtils()
  //if (!isIntegrationEnabled('kustomer')) return

  function load() {
    const script = document.createElement('script')
    script.src = 'https://cdn.kustomerapp.com/chat-web/widget.js'
    script.async = true
    script.setAttribute(
      'data-kustomer-api-key',
      'eyJhbGciOiJub25lIn0.eyJvcmciOiI2MjQzODE2ZTVhNThmYjIzNjY4YTc3ZmEiLCJvcmdOYW1lIjoicmVhbHRydWNrLXNhbmRib3giLCJyb2xlcyI6WyJvcmcudHJhY2tpbmciXX0.'
    )
    script.onload = () => {
      window.Kustomer.start({
        brandId: '62438175ac04987b28113f2d',
      })
    }
    document.body.appendChild(script)
  }

  runOnNuxtReady(() => {
    //if (isIntegrationEnabled('ketch')) {
    //  $ketch.onConsentResolved(() => {
    //  if (!$ketch.hasConsent.value) return

    load()

    // })
    //} else {
    //  load()
    //}
  })

  return {
    provide: {
      chat: {
        open() {
          if (!window.Kustomer) return
          window.Kustomer.open()
        },
      },
    },
  }
})
